module.exports = __webpack_public_path__ + "img/layers.c9ba8008.svg";